'use client';
import {Box} from '@mui/material';
import {Chip} from '../../primitives';
import type {ListingCardBadge} from './types';

export interface ListingCardBadgesProps {
  badges: ListingCardBadge[];
}

export function ListingCardBadges({badges}: ListingCardBadgesProps) {
  if (badges.length === 0) {
    return null;
  }
  const badgesToRender = badges.slice(0, 1);
  return (
    <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
      {badgesToRender.map((badge, index) => (
        <Chip key={index} iconLeft={badge.icon} sx={{alignSelf: 'flex-start', maxWidth: '100%'}}>
          <Box component="span" sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
            {badge.label}
          </Box>
        </Chip>
      ))}
    </Box>
  );
}

ListingCardBadges.displayName = 'ListingCardBadges';
